export const displayTorchErrorPopupSelector = ({displayTorchErrorPopup}) => displayTorchErrorPopup